import script from "./productDealsColumn.vue?vue&type=script&setup=true&lang=js"
export * from "./productDealsColumn.vue?vue&type=script&setup=true&lang=js"

import "./productDealsColumn.vue?vue&type=style&index=0&id=24dada95&lang=less"

const __exports__ = script;

export default __exports__